import '../Scss/style.scss';
import { defineAsyncComponent } from 'vue';
import { Component } from '@vue/runtime-core';
import createApp, { VueDsCookies } from '@digitalwerk/frontend-muster';

const NewsList = defineAsyncComponent(() => import('./Components/NewsList.vue'));
const Search = defineAsyncComponent(() => import('./Components/Search.vue'));
const QuoteSlider = defineAsyncComponent(() => import('./Components/QuoteSlider.vue'));
const PosterSlider = defineAsyncComponent(() => import('./Components/PosterSlider.vue'));
// GravityForm component and inputs
const GravityForm = defineAsyncComponent(() => import('./Components/GravityForm.vue'));
const GfCheckboxes = defineAsyncComponent(() => import('./Components/GravityFormElements/Checkboxes.vue'));
const GfConsent = defineAsyncComponent(() => import('./Components/GravityFormElements/Consent.vue'));
const GfFileUpload = defineAsyncComponent(() => import('./Components/GravityFormElements/FileUpload.vue'));
const GfInput = defineAsyncComponent(() => import('./Components/GravityFormElements/Input.vue'));
const GfRadioButtons = defineAsyncComponent(() => import('./Components/GravityFormElements/RadioButtons.vue'));
const GfSelect = defineAsyncComponent(() => import('./Components/GravityFormElements/Select.vue'));
const GfTextarea = defineAsyncComponent(() => import('./Components/GravityFormElements/Textarea.vue'));
// const CookiesInfoBox = defineAsyncComponent(() => import('./Components/cookies/InfoBox.vue'));

// // import * as Sentry from "@sentry/vue";
//
// //TODO: Vue Sentry, DNS must be https
// // Sentry.init({
// //     Vue: Vue,
// //     dsn: "http://4d7eadae930d4b6eae70a46050ff6f4e@195.2.221.3:9000/5",
// // });
// // Vue.config.errorHandler = function (err, vm, info) {
// //     Sentry.captureMessage(err.toString())
// // }
// // Vue.config.warnHandler = function (msg, vm, trace) {
// //     Sentry.captureMessage(msg.toString())
// // }

const projectRootComponent:Component = {
  components: {
    'news-list': NewsList,
    'quote-slider': QuoteSlider,
    'poster-slider': PosterSlider,
    search: Search,
    'gravity-form': GravityForm,
    'gf-checkboxes': GfCheckboxes,
    'gf-consent': GfConsent,
    'gf-file-upload': GfFileUpload,
    'gf-input': GfInput,
    'gf-radio-buttons': GfRadioButtons,
    'gf-select': GfSelect,
    'gf-textarea': GfTextarea,
    // 'cookies-info-box': CookiesInfoBox,
  },
  methods: {
    closeSubNav() {
      const body = document.querySelector('body.mobile-nav-opened');
      if (body) {
        body.classList.remove('mobile-nav-opened');
      }
    },
  },
};

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const app = createApp(projectRootComponent);

// app.use(VueDsCookies);

app.mount('#page');
